// src/pages/ProcessingRecipesList.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import config from "../../config"; 
import Layout from "../../components/layouts/Main";
import { FaAngleDoubleRight } from "react-icons/fa";

const ProcessingRecipesList = () => {
    const [recipes, setRecipes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRecipes = async () => {
            try {
                const res = await axios.get(`${config.API_BASE_URL}/process-definitions`);
                setRecipes(res.data);
            } catch (err) {
                console.error("Error fetching recipes", err);
            } finally {
                setLoading(false);
            }
        };
        fetchRecipes();
    }, []);

    return (
        <Layout>
            {/* Breadcrumb */}
            <nav aria-label="breadcrumb" className="mb-3">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                    <li className="breadcrumb-item active">Bill Of Materials (BOM)</li>
                </ol>
            </nav>

            {/* Bill Of Materials (BOM) Header */}
            <Row className="gy-3">
                <Col className="col"><h2>Bill Of Materials (BOM)</h2></Col>
                <Col className="text-end col-auto">
                    <div className="d-flex justify-content-end flex-wrap gap-2">
                        <Link to="/boms/add" className="btn btn-primary">
                            <i className="fas fa-plus me-2" /> Create BOM
                        </Link>
                    </div>
                </Col>
            </Row>

            <Container fluid className="mb-6">
                {loading ? (
                    <div className="text-center my-5">
                        <PulseLoader color="#014b7cbb" size={9} />
                    </div>
                ) : (
                    <Row xs={1} md={2} xl={3} className="g-4">
                        {recipes.map((r) => (
                            <Col key={r._id}>
                                <Card className="h-100">
                                    <Card.Body>
                                        <Card.Title className="mb-0">{r.name}</Card.Title>
                                        <Card.Text className="text-muted mt-1 fs-85">
                                            {r.bomId || "No Id"}
                                        </Card.Text>
                                    </Card.Body>
                                    <Card.Footer className="py-3">
                                        <div className="d-flex align-items-center justify-content-between gap-2">
                                            <small className="text-muted">
                                                Created: {new Date(r.createdAt).toLocaleDateString("en-IN")}
                                            </small>
                                            <Link to={`/boms/${r._id}`} className="btn btn-sm btn-outline-primary">View <FaAngleDoubleRight /></Link>
                                        </div>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}
            </Container>
        </Layout>
    );
};

export default ProcessingRecipesList;
